import { Container, StyledInput } from "./style";

const InputFieldsetWithoutLegend = ({type, value, onChange, placeholder, backgroundColor, disabled}) => {

    return (
        <Container>
            <StyledInput 
                type={type} 
                disabled={disabled}
                backgroundColor={backgroundColor}
                value = {value} 
                onChange = {(event) => onChange(event.target.value)}
                placeholder = {placeholder}
            />
        </Container>
    );
}

export default InputFieldsetWithoutLegend;